import { securedAxiosInstance } from "./axios";
import i18n from '../i18n'

export default {
    async retrieve(retrieveUrl, data) {
        return securedAxiosInstance.get(retrieveUrl)
        .catch (error => {
            return {error: error, readable: i18n.t('responses.retrieveError', {data: data})}
        })
    },
    
    async send(sendUrl, data, body) {
        return securedAxiosInstance.post(sendUrl, {
            body
        })
        .catch (error => {
            return {error: error, readable: i18n.t('responses.sendError', {data: data})}
        })
    },

    async retrieveWithBody(sendUrl, data, body) {
        return securedAxiosInstance.post(sendUrl, {
            body
        })
        .catch(error => {
            return {error: error, readable: i18n.t('responses.retrieveError', {data: data})}
        })
    }
}